import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DropdownInput, NumberInput } from "components/table/carousel/inputs"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { InputText_s } from "styles/input-styles"
import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const InputTypeDetailed = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    compoundType: null,
    effectiveMonth: null
  }

  const emptyItem = {
    year: 1,
    amt: null
  }

  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }})) : [{...emptyItem, i: 0}]);
  const [data, setData] = useState<object|null>({...props.rowData[props.field]})

  function updateVal(val:any, field:string|string[]):void {
    let newData = _.cloneDeep(data)
    if(_.isArray(field)) {
      if(items[field[0]][field[1]] === val) return
      items[field[0]][field[1]] = val
    } else {
      _.set(newData, field, val)
    }
    setData(newData)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => item.year = i+1);
    _.set(newData, 'items', strippedItems)
    if (!newData['compoundType']) _.set(newData, 'compoundType', compoundTypeDefault);
    if (!newData['effectiveMonth']) _.set(newData, 'effectiveMonth', 'Market Effective Month');
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest))
    strippedItems.map((item, i) => item.year = i+1);
    _.set(newData, 'items', strippedItems)
    if (!newData['compoundType']) _.set(newData, 'compoundType', compoundTypeDefault);
    if (!newData['effectiveMonth']) _.set(newData, 'effectiveMonth', 'Market Effective Month');
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i');
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setData(emptyRecord);
      setItems([{...emptyItem, i: 0}]);
    } else {
      setData({...props.rowData[props.field]});
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('inflation', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('inflation', `${props.field}.items`)(field)(props.rowData, props)
  const compoundTypeDefault = props.defaults['inflationCompoundType'];

  return (
    <div>
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>Compound Type</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="compoundType" options={['Annual', 'Monthly']} persist={updateVal} default={compoundTypeDefault} />
        </div>
        <div>
          <label>Effective Month</label>
          <DropdownInput className="automated" data={data} attrs={attrs} default="Market Effective Month" field="effectiveMonth" options={['Market Effective Month', 'Recovery Effective Month', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']} persist={updateVal} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Year</label> }
              <InputText_s readOnly value={i+1} className="year-input" />
            </div>
            <div>
              { i === 0 && <label>Amt</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'amt']} {...params} readPrecision={4} writePrecision={4} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
    </div>
  )
}

export default InputTypeDetailed
